import { Arg, Metadata } from '../../../utils/spds/metadata';
import { concat } from '@ember/helper';
import { htmlSafe } from '@ember/template';
import { warn } from '@ember/debug';
import FlexRow from '../layout/flex/row.gjs';
import Super from './base.gjs';
import styles from './progress-bar.module.scss';

const METADATA = Metadata.define({
  description:
    'Reusable progress bar. Used in Spds::Modal::FullScreen. Sets width of progress bar based on (currentStep / stepCount) * 100',
  meta: {
    absolute: Arg.boolean({
      default: true,
      description: 'Whether the progress bar should use absolute positioning',
    }),
    currentStep: Arg.number({
      description: 'The current step number in the progress sequence',
    }).initial(1),
    stepCount: Arg.number({
      description: 'The total number of steps in the progress sequence',
    }).initial(4),
  },
  name: 'Progress Bar',
});

export default class SpdsCoreProgressBar extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-progress-bar-container';
  styles = styles;

  get absolute() {
    return this.argOrDefault('absolute');
  }

  get currentStep() {
    return this.argOrDefault('currentStep');
  }

  get stepCount() {
    return this.argOrDefault('stepCount');
  }

  get progressPercentage() {
    let { currentStep, stepCount } = this;

    if (stepCount < 1) return '0%';

    warn(
      `currentStep (${currentStep}) should be lower than stepCount (${stepCount})`,
      currentStep <= stepCount,
      {
        id: 'spds-progress-bar.current-step-out-of-range',
      }
    );

    return `${(currentStep / stepCount) * 100}%`;
  }

  <template>
    <FlexRow
      @absolute={{this.absolute}}
      @fitContentHeight={{true}}
      class={{this.classes}}
      data-test-spds-progress-bar-container
      {{this.validateArguments}}
      ...attributes
    >
      <FlexRow
        class="spds-progress-bar"
        data-test-spds-progress-bar
        style={{htmlSafe (concat "width: " this.progressPercentage)}}
      />
    </FlexRow>
  </template>
}

export const SPDS_CORE_PROGRESS_BAR_METADATA = SpdsCoreProgressBar.metadata;
